import { Game } from "@smerf-gaming/types"
import axios from "axios"

export const getGames = async (): Promise<Game[] | null> => {
  try {
    const res = await axios.get("/games", { params: { adminIncludeHidden: 1 } })
    return res.data
  } catch (err) {
    console.log("getGames  err", err)
  }
  return null
}
